<template>
  <div class="account-header">
    <div class="header-content">
      <div class="header-left">
        <complete-logo style="float: left; margin-top: 10px" />
        <div class="vertical-line" />
        <span>{{ title }}</span>
      </div>
      <div class="header-right">
        <span>{{ other_info }}</span>
        <router-link :to="jump_link">
          {{ jump_title }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { CompleteLogo } from '@/components'

export default {
  name: 'AccountHeader',
  components: {
    CompleteLogo
  },
  props: {
    page_type: {
      type: String,
      default: 'user_login'
    }
  },
  data() {
    return {
      id: 1,
      title: '家长登录',
      jump_link: '/account/teacher-login',
      jump_title: '教员登录',
      other_info: ''
    }
  },
  created() {
    if (this.page_type === 'user_login') {
      this.title = '家长登录'
      this.jump_link = '/account/teacher-login'
      this.jump_title = '教员登录'
    } else if (this.page_type === 'user_register') {
      this.title = '家长注册'
      this.jump_link = '/account/user-login'
      this.jump_title = '去登录'
      this.other_info = '已有账号，'
    } else if (this.page_type === 'user_retrieve_pass') {
      this.title = '找回密码'
      this.jump_link = '/account/user-login'
      this.jump_title = '去登录'
    } else if (this.page_type === 'user_reset_pass') {
      this.title = '重置密码'
      this.jump_link = '/account/user-login'
      this.jump_title = '家长登录'
    } else if (this.page_type === 'teacher_login') {
      this.title = '教员登录'
      this.jump_link = '/account/user-login'
      this.jump_title = '家长登录'
    } else if (this.page_type === 'teacher_register') {
      this.title = '教员注册'
      this.jump_link = '/account/teacher-login'
      this.jump_title = '去登录'
      this.other_info = '已有账号，'
    } else if (this.page_type === 'teacher_retrieve_pass') {
      this.title = '找回密码'
      this.jump_link = '/account/teacher-login'
      this.jump_title = '去登录'
    } else if (this.page_type === 'teacher_reset_pass') {
      this.title = '重置密码'
      this.jump_link = '/account/teacher-login'
      this.jump_title = '教员登录'
    }
  }
}
</script>

<style lang="stylus">
.account-header {
  width: 100%;
  height: 60px;
  background-color: #ffffff;
  box-shadow: 0px 3px 7px 0px rgba(216, 216, 216, 0.3);

  .header-content {
    height: 60px;
    width: $container-width;
    margin: auto;
    padding: 0px 10px;
    position: relative;

    .header-left {
      height: 100%;
      min-width: 285px;
      overflow: hidden;

      position: absolute;

      .vertical-line {
        content: '';
        height: 40px;
        width: 1px;
        background: #000000;
        float: left;
        margin-top: 10px;
        margin-left: 15px;
      }

      span {
        font-family: MicrosoftYaHei;
        font-size: 24px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
        float: left;
        margin-top: 10px;
        margin-left: 15px;
      }
    }

    .header-right {
      max-width: 150px;
      height: 100%;
      line-height: 60px;
      position: absolute;
      right: 10px;

      span {
        width: 100%;
        height: 16px;
        font-family: MicrosoftYaHeiLight;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 25px;
        letter-spacing: 0px;
        color: #999999;
      }

      a {
        width: 65px;
        height: 16px;
        font-family: MicrosoftYaHeiLight;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 25px;
        letter-spacing: 0px;
        color: #fa750d;
      }
    }
  }
}
</style>
